import { useEffect, useState } from 'react'

// Should this visit play the hero video?
//
// Three conditions, all of them someone else's decision rather than ours
// (docs/MARKETING-SITE-SPEC.md §6.2):
//   · a wide enough viewport. On a phone the still carries the same message, and
//     a few megabytes of video is somebody's data allowance
//   · prefers-reduced-motion is not set. Motion makes some people ill
//   · the connection is not in data saver mode
//
// It always starts FALSE, including during the prerender, so the server rendered
// HTML ships the poster and the video is a decision taken after hydration. That
// is also what keeps the video off the critical path: the poster is the LCP
// element and the video must never compete with it.

const MIN_WIDTH = 768

export function useHeroVideo() {
  const [play, setPlay] = useState(false)

  useEffect(() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)')
    const wide   = window.matchMedia(`(min-width: ${MIN_WIDTH}px)`)
    const saver  = () => navigator.connection?.saveData === true

    const decide = () => setPlay(wide.matches && !motion.matches && !saver())

    // Wait for load, so the video never competes with first paint.
    if (document.readyState === 'complete') decide()
    else window.addEventListener('load', decide, { once: true })

    motion.addEventListener('change', decide)
    wide.addEventListener('change', decide)
    return () => {
      motion.removeEventListener('change', decide)
      wide.removeEventListener('change', decide)
    }
  }, [])

  return play
}
